import React, { useEffect, useRef, useState } from "react";
import * as S from "./styles.ts";

const TrustBox = () => {
  const trustBoxRef = useRef(null);

  useEffect(() => {
    const loadTrustpilot = () => {
      if ((window as any).Trustpilot) {
        (window as any).Trustpilot.loadFromElement(trustBoxRef.current, true);
      }
    };

    if (
      !document.querySelector(
        'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]'
      )
    ) {
      const script = document.createElement("script");
      script.src =
        "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      script.async = true;
      script.onload = loadTrustpilot;
      document.body.appendChild(script);
    } else {
      loadTrustpilot();
    }
  }, []);

  return (
    <S.Wrapper
      ref={trustBoxRef}
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id="53aa8912dec7e10d38f59f36"
      data-businessunit-id="55a6582b0000ff00058113ab"
      data-style-height="100%"
      data-style-width="100%"
      data-stars="4,5"
      data-review-languages="en"
    >
      <a
        href="https://uk.trustpilot.com/review/yay.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </S.Wrapper>
  );
};

export default TrustBox;
